import { useState, useEffect, useCallback } from 'react'
import { selectLocation } from '../menu/filtersSlice'
import { LOCATION_STATES } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import { selectPlaces } from './locationSlice'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ResultList from './ResultList'
import Filters from './Filters'

const Result = ({ expanded, menuRef, show }) => {
  const [animate, setAnimate] = useState(false)

  const location = useSelector(selectLocation)
  const data = useSelector(selectPlaces)

  const { t } = useTranslation()
  const { push, location: { pathname } } = useHistory()

  useEffect(() => {
    if (!expanded && !!location && data?.filteredAndLocalized?.length > 0) {
      setAnimate(true)
    }
  }, [expanded, data, location])

  useEffect(() => {
    if (expanded) setAnimate(false)
  }, [expanded])


  const showFilters = useCallback(() => push(pathname, LOCATION_STATES.popup('filters')), [pathname, push])

  return (
    <div
      className={`map__result --full ${animate ? '--animate' : ''}`}
      onClick={() => setAnimate(false)}>

      <div className='result__header'>
        <div className='header__main group'>
          <div
            className='header__title'
            onClick={show}>{t('map.showListOfMags')}</div>

          <div
            className='result__filter'
            onClick={showFilters}>
            <i className='icon icon--filter' />
            <span>{t('filters.filter')}</span>
          </div>
        </div>
      </div>

      <Filters
        menuRef={menuRef}
        showFilters={showFilters}
      />

      {expanded && <ResultList />}
    </div >
  )
}

export default Result